import Button from "@/lib/Button";
import Input from "@/lib/Input";
import { useState } from "react";
import toast from "react-hot-toast";
import Layout from "./Layout";
import StyledLink from "@/lib/StyledLink";
import $api from "@/lib/queries/openapi";
import { useQueryClient } from "@tanstack/react-query";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const emailValid = email.length;
  const passwordValid = password.length;
  const queryClient = useQueryClient();

  const { mutate: login, isPending } = $api.useMutation(
    "post",
    "/api/auth/login",
    {
      onError: ({ errors }) =>
        toast.error(`Login failed: ${errors.map((e) => e.message).join(", ")}`),
      onSuccess: () => {
        queryClient.invalidateQueries();
      },
    },
  );

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        login({ body: { email, password } });
      }}
    >
      <Layout title="Sign in">
        <>
          <Input
            label="Email"
            value={email}
            onChange={setEmail}
            type="email"
            placeholder="Email"
            autoComplete="on"
            name="email"
          />
          <Input
            label="Password"
            value={password}
            onChange={setPassword}
            type="password"
            placeholder="Password"
          />
          <Button
            primary
            size="lg"
            disabled={!emailValid || !passwordValid}
            loading={isPending}
          >
            Sign in
          </Button>
          <div className="flex justify-between">
            <StyledLink to="/forgot-password">Forgot Password</StyledLink>
          </div>
        </>
      </Layout>
    </form>
  );
}
